import * as React from "react";
import Session from "services/Session";

interface IState {
    lastUpdateDate: Date;
}

interface IProps {
    size?: "1x" | "2x"
}

type Props = IProps;

class AppLogo extends React.PureComponent<Props, IState> {

    constructor(props: Props) {
        super(props);
        this.state = { lastUpdateDate: Session.appTheme.lastUpdateDate };
    }

    static defaultProps = {
        size: "1x"
    }

    private monitoringChange = () => {
        this.setState({ lastUpdateDate: Session.appTheme.lastUpdateDate });
    }

    public componentWillMount() {
        Session.subscribe(this.monitoringChange);
    }

    public componentWillUnmount() {
        Session.unsubscribe(this.monitoringChange);
    }

    render() {
        return (
            <img
                src={`/api/v1.0/Session/Logo?t=${new Date(this.state.lastUpdateDate).getTime()}`}
                alt="Logotipo"
                height={this.props.size == "1x" ? 64 : 128}
                width={this.props.size == "1x" ? 128 : 256}
            />
        );
    }
}

export default AppLogo;
